<div class="mode-toast mode-toast--{{ type }}" [class.pointer]="canTapToDismiss">
  <capra-icon *ngIf="icon && !hideIcon" class="mode-toast__icon" [icon]="icon"></capra-icon>

  <div data-test="toast-content" class="toast-content">
    <ng-content></ng-content>
  </div>

  <div *ngIf="showCloseBtn" class="close-btn-container close-btn-container--{{ closeBtnPosition }}">
    <capra-icon class="close-btn" icon="icon-close" (click)="dismissToast.emit()"></capra-icon>
  </div>
</div>
